(function IIFE (arr) {
arr.forEach((item) => {
  if (item.hasOwnProperty('remove')) { // eslint-disable-line no-prototype-builtins
    return
  }

  // eslint-disable-next-line no-restricted-globals
  Object.defineProperty(item, 'remove', {
    configurable: true,
    enumerable: true,
    writable: true,
    // eslint-disable-next-line no-restricted-syntax -- Ennek nem szabad arrow-nak lennie!
    value: function remove () {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, no-restricted-properties, no-restricted-syntax
      this.parentNode?.removeChild(this)
    }
  })
})
// eslint-disable-next-line no-restricted-globals
})([ Element.prototype, CharacterData.prototype, DocumentType.prototype ].filter(Boolean))
